export const formatPercentage = (value: number, precision = 2) => Number.parseFloat(value.toFixed(precision));
